var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("AuthWarning", {
    attrs: {
      title: "Access denied",
      message:
        "Your ProveraCare company subscription has been temporarily suspended. Please contact your admin to get access.",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }